import { Action, Reducer } from 'redux';
import { YearState, YearTypes, YearActionTypes } from './yearTypes';
import {
  haskeyReducer,
  resetIsolatedReducer,
  updateGetIsolated,
  updateSaveIsolated
} from '@/main/services/reducerUtils';

export const INITIAL_STATE: YearState = {
  years: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const yearReducer: Reducer<YearState> = (
  state: YearState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as YearActionTypes;
  switch (actionTypes.type) {
    case YearTypes.GET_YEARS:
    case YearTypes.GET_YEARS_BY_MANUFACTURER_AND_MODEL:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        years: { ...state.years, isLoading: true }
      };
    case YearTypes.SAVE_YEARS:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

      return {
        ...state,
        years: {
          ...state.years,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case YearTypes.RESET_REDUCER_YEARS:
      const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

      return {
        ...state,
        years: INITIAL_STATE.years
      };
    default:
      return state;
  }
};

export default yearReducer;

